import { useMemo } from "react";

import { useSelector } from "react-redux";

import { EMPTY_SDK_DESCRIPTIONS } from "app/pages/sales-intelligence/domain/sdk/constants/model";
import { EMPTY_GROUPED_TECHNOLOGIES } from "app/pages/sales-intelligence/domain/technology/constants/model";
import useSdkDescriptionsQuery from "app/pages/sales-intelligence/modules/apps/queries/useSdkDescriptionsQuery";
import useGroupedTechnologiesQuery from "app/pages/sales-intelligence/modules/technology/queries/useGroupedTechnologiesQuery";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import settingsService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/sw-settings/settingsService";
import {
    selectIntentSignalCountriesDetails,
    selectIntentSignalSelectedTopics,
} from "app/pages/sales-intelligence/sub-modules/intent/store/signal/selectors/selectors";
import { NEWS_CATEGORIES_BY_TYPE } from "app/pages/sales-intelligence/sub-modules/signals/utils/news/const";

import { selectSignalsDescription, selectSignalsSource } from "../../../sub-modules/signals/store/selectors";
import createSignalFiltersViewResolver from "../services/signals-filters-view-resolver/factory";

export default function useSignalFiltersViewResolver() {
    const signalsDescription = useSelector(selectSignalsDescription);
    const intentSelectedTopics = useSelector(selectIntentSignalSelectedTopics);
    const intentUserCountries = useSelector(selectIntentSignalCountriesDetails);
    const signalSource = useSelector(selectSignalsSource);

    const { data: signalTechnologies = EMPTY_GROUPED_TECHNOLOGIES } = useGroupedTechnologiesQuery();
    // This hook only mounts with the signals modal open, and the Lead Gen filters config already
    // primed the shared apps-description cache, so this resolves from cache rather than refetching.
    const { data: sdkDescriptions = EMPTY_SDK_DESCRIPTIONS, isPending: isSdkDescriptionsPending } =
        useSdkDescriptionsQuery({ enabled: salesSettingsHelper.isAppsSignalsEnabled });

    return useMemo(() => {
        return createSignalFiltersViewResolver({
            adNetworks: signalsDescription?.adNetworks ?? [],
            countries: settingsService.getCurrentComponentCountries(),
            technologies: signalTechnologies,
            newsCategories: NEWS_CATEGORIES_BY_TYPE,
            intentSelectedTopics: intentSelectedTopics ?? [],
            intentUserCountries: intentUserCountries ?? [],
            signalSource,
            sdkDescriptions,
            isSdkDescriptionsPending,
        });
    }, [
        signalsDescription?.adNetworks,
        signalTechnologies,
        intentSelectedTopics,
        intentUserCountries,
        signalSource,
        sdkDescriptions,
        isSdkDescriptionsPending,
    ]);
}
